export enum Status {
  Error = "error",
  Notice = "notice",
  Success = "success",
}

export interface FlashError extends JQueryXHR {
  responseJSON: { flash: string };
}

declare global {
  interface Window {
    displayFlash: (status: Status, text: string) => void;
  }
}

export const displayFlash = (status: Status, text: string): void => window.displayFlash(status, text);
